<template>
  <div class="process-main">
    <span v-if="detail.appointDays > 0">请于 {{ time }} 后，拍下宝贝</span>
    【单价：
    <span class="text-red-500">{{ detail.goodsPrice }}</span>
    ，购买数量：
    <span class="text-red-500">{{ detail.goodsNum }}</span>
    ，规格：
    <span class="text-red-500">{{ detail.spec }}</span>
    】
    <div class="process-b-item" v-if="detail.attachGoodsList && detail.attachGoodsList.length > 0">
      <span class="text-red-500">此任务为多链接任务，除了宝贝外还有下面这些附带宝贝，要一起下单</span>
      <div class="mb-1" v-for="item in detail.attachGoodsList">
          <div class="process-b-item-content flex-row">
            <el-image
              class="mr-4"
              style="width: 100px; height: 100px"
              :src="item.imgs"
              :key="imgs"
              fit="cover"
            ></el-image>
            <div class="flex-col" style="margin-top: 10px;">
              <div>单价：{{ item.goodsPrice }}</div>
              <div>数量：{{ item.goodsNum }}</div>
              <div>规格：{{ item.spec }}</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import uploader from "@/components/uploader";
export default {
  name: "",
  components: {
    uploader,
  },
  props: {
    stepData: {
      type: Object,
    },
    detail: Object,
  },
  watch: {
    
  },
  computed: {
    userInfo() {
      return this.$store.state.user;
    },
    time() {
      let date = new Date();
      if(this.detail.searchTime){
        date = new Date(this.detail.searchTime)
      }
      if(this.detail.appointDays > 0){
        date = new Date(this.detail.publishTime);
      }
      let time = date.getTime();
      if(this.detail.appointDays > 0){
        time = time + (this.detail.appointDays - 1) * 1000 * 3600 * 24
      }
      return moment(time).format("MM-DD");
    },
  },
  mounted() {
    this.$emit("update-done", true);
  },
  data() {
    return {
      isDone: false,
      data: {},
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.process-main {
  .process-b-item {
    padding: 0.5rem 0;

    .process-b-item-content {
      margin-top: 0.5rem;
    }
    .process-b-item-content_flex {
      display: flex;
      align-items: center;
    }
  }

  .process-b-item-content {
    display: flex;
    margin-top: 30px;
  }
}

.avatar-uploader /deep/.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
